import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSecondFeatureData } from '../api/secondFeature.api';

export const getSecondFeature = createAsyncThunk(
  'SecondFeature/getSecondFeature',
  async (params: any | undefined, thunkAPI) => {
    try {
      // Default parameters for fetching second feature
      const defaultParams: any = {
        size: 10,
      };
      // Call API to get second feature data
      const response = await getSecondFeatureData(params ?? defaultParams);
      return response;
    } catch (e) {
      // Return error if API call fails
      return thunkAPI.rejectWithValue(e);
    }
  }
);